import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayOfYear from "dayjs/plugin/dayOfYear";
import duration from "dayjs/plugin/duration";
import isLeapYear from "dayjs/plugin/isLeapYear";
import isoWeeksInYear from "dayjs/plugin/isoWeeksInYear";
import localeData from "dayjs/plugin/localeData";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekOfYear from "dayjs/plugin/weekOfYear";

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(weekOfYear);
dayjs.extend(dayOfYear);
dayjs.extend(isLeapYear);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeeksInYear);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(quarterOfYear);

const DateUtil = function () {
    const util = {};

    /**
     * Get the minimum DOB allowed by the database.
     *
     * Trying to store a DOB before January 1, 1850 will throw an exception
     * in the database.
     */
    util.getMinimumDateOfBirth = () => {
        return "1850-01-01";
    };

    util.addToDate = (time, unitTime, date) =>
        date ? dayjs(date).add(time, unitTime) : dayjs().add(time, unitTime);

    util.getDate = (date) => (date ? dayjs(date) : dayjs());

    util.subtractFromDate = (time, unitTime, date) => {
        return date ? date.subtract(time, unitTime) : dayjs().subtract(time, unitTime);
    };

    util.isSame = (firstDate, secondDate) => dayjs(firstDate).isSame(dayjs(secondDate));

    util.isAfter = (prevDate, oldDate) => dayjs(prevDate).isAfter(oldDate);

    util.isBefore = (prevDate, oldDate) => dayjs(prevDate).isBefore(oldDate);

    util.getYear = (date) => dayjs(date).year();
    util.getMonth = (date) => dayjs(date).month() + 1;
    util.getDay = (date) => dayjs(date).date();

    util.getUTCFormatted = (date, format) => dayjs(date).utc().format(format);

    util.formatExistingDate = (format, date) => date.format(format);

    util.getDateFormatted = (format, date) =>
        date ? dayjs(date).format(format) : dayjs().format(format);

    util.getMonthsShort = () => dayjs.monthsShort();

    util.getTimeDuration = (time, unitTime) => dayjs.duration({ time, unitTime });

    util.getUnix = (number) => dayjs.unix(number);

    util.getValueOf = (date) => (date ? dayjs(date).valueOf() : dayjs().valueOf());

    util.getUTCOffset = () => dayjs().utcOffset();

    util.getRange = (startDate, endDate) => dayjs(startDate).to(endDate);

    util.getCalendar = (date) => {
        //equivalent to moment().calendar();
        return dayjs(new Date(date).setHours(0, 0, 0, 0))
            .utc()
            .toDate();
    };

    util.isValid = (date, format, flag = false) => dayjs(date, format, flag).isValid();

    util.diff = (firstDate, secondDate, unitTime, flag = true) =>
        dayjs(firstDate).diff(secondDate, unitTime, flag);

    util.isDayjs = (date) => dayjs.isDayjs(dayjs(date));

    util.getTimeZone = (timeStamp, timeZone) => dayjs(timeStamp).tz(timeZone);

    util.swapDateFormat = (date, oldFormat, newFormat) => {
        return dayjs(date, oldFormat).format(newFormat);
    };

    util.getGenericFormat = (date, anyFormat) => {
        return dayjs(date, anyFormat);
    };

    util.dayOfYear = (d, n) => dayjs(d).dayOfYear(n);

    util.getQuarterStart = () => dayjs().startOf("quarter");

    return util;
};

export default DateUtil();
